module.exports = __webpack_public_path__ + "static/img/indexOk.ee9ed22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/indexOk.png
// module id = 6REc
// module chunks = 1